<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="pvii"></a><span epub:type="pagebreak" id="pagevii" title="vii"><a id="contents"></a>Contents</span></h2>
<p class="toc"><a href="#/xhtml/list">List of illustrations</a></p>
<p class="toc"><a href="#/xhtml/map1">Map 1: West Highlands and Islands</a></p>
<p class="toc"><a href="#/xhtml/map2">Map 2: Moray Firth Area</a></p>
<p class="toc"><a href="#/xhtml/key">Some key characters</a></p>
<p class="toc1"><a href="#/xhtml/introduction">Introduction</a></p>
<p class="tocc"><a href="#/xhtml/chapter01"><span class="to">1</span> ‘A winter of starvation’</a></p>
<p class="tocc"><span href="#/xhtml/chapter02" title="Link target outside of Sample"><span class="to">2</span> ‘Disorderly, tumultuous and turbulent assemblages’</span></p>
<p class="tocc"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><span class="to">3</span> ‘The year potatoes went away’</span></p>
<p class="tocc"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><span class="to">4</span> ‘A pointed pistol in each hand’</span></p>
<p class="tocc"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><span class="to">5</span> ‘The sheriff of Elginshire is overpowered’</span></p>
<p class="tocc"><span href="#/xhtml/chapter06" title="Link target outside of Sample"><span class="to">6</span> ‘Acts of the most disgraceful character’</span></p>
<p class="tocc1"><span href="#/xhtml/chapter07" title="Link target outside of Sample"><span class="to">7</span> ‘Chains of degradation’</span></p>
<p class="toc"><span href="#/xhtml/ack" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/xhtml/bib" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span><a id="pviii"></a><span epub:type="pagebreak" id="pageviii" title="viii"></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4d21f077